// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "babel-polyfill";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import $ from "jquery";
Vue.prototype.$ = $;
Vue.use(ElementUI);
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts
const echarts = require("echarts");
Vue.prototype.$echarts = echarts;
import authSource from "./components/authSource.vue";
Vue.prototype.authSource = authSource.authSource;
import "./assets/css/index.css";
import tool from "./api/tool";
import "@wangeditor/editor/dist/css/style.css";
import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
import "vue-video-player/src/custom-theme.css";
Vue.use(tool);
Vue.use(VideoPlayer);
window.addEventListener("setItemEvent", function(e) {
  //e.key : 是值发生变化的key
  //e.newValue : 是可以对应的新值
  if (e.key === "token") {
    if (e.newValue != localStorage.getItem("token")) location.reload();
  }
});
Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js